import { css } from '@emotion/react';

// https://unsplash.com/photos/a-woman-sitting-at-a-table-looking-at-her-cell-phone-1JnN9QhmTGU
import image from 'src/assets/jpg/payment.jpg';
import { theme } from 'src/styles/theme';

export const styles = {
    container: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    }),

    imageContainer: css({
        marginBottom: '50px',
        height: '190px',
        flexShrink: '0',
        background: `url(${image}) lightgray no-repeat center center`,
        backgroundSize: '150%',

        [theme.breakpoints.up('md')]: {
            backgroundSize: '100%',
        },
    }),

    wrapper: css({
        padding: '0 20px',
        alignSelf: 'center',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '30px',
        [theme.breakpoints.up('md')]: {
            width: '494px',
            gap: '40px',
        },
    }),

    cta: css({
        display: 'flex',
        height: '45px',
        padding: '16px 16px 12px 16px',
        justifyContent: 'center',
        gap: '30px',
        alignItems: 'stretch',
        borderRadius: '100px',
        paddingBlock: '16px',
        width: '100%',
        alignSelf: 'stretch',

        [theme.breakpoints.up('md')]: {
            width: '186px',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    }),

    sageWrapper: css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '30px',
        gap: '20px',
        alignSelf: 'stretch',
        marginBottom: '83px',
    }),
};
